// Admin auth client — single admin, JWT in localStorage, 24h expiry.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bgb_admin_token";

export function getToken() {
  return typeof window === "undefined" ? null : localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return data;
}

export async function adminStats() {
  const { data } = await axios.get(`${API}/admin/stats`, { headers: authHeaders() });
  return data;
}

export async function adminContacts() {
  const { data } = await axios.get(`${API}/admin/contacts`, { headers: authHeaders() });
  return data;
}

export async function adminReadiness() {
  const { data } = await axios.get(`${API}/admin/readiness-completions`, { headers: authHeaders() });
  return data;
}

export function adminContactsExportUrl() {
  // CSV export — backend reads token from header, so we fetch and trigger a blob download.
  return `${API}/admin/contacts/export`;
}

export async function downloadContactsCsv() {
  const res = await axios.get(adminContactsExportUrl(), {
    headers: authHeaders(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `bigibila-contacts-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
